//@flow
import React from "react";
import Field from "../field";
import css from "../form.module.scss";
import { Validator } from "../../services/validators";
import FormParent from "../form-parent";

export class Form extends FormParent {
  constructor(props: Object) {
    super(props);

    this.Required = [
      "name",
      // "dob",
      // "address",
      // "postcode",
      "contact_number",
      "email",
      // "gender",

      // "reason",
      // "answer",
      "marketing_optin",
    ];

    this.state.data = { competition_id: "idr-2026-jamaica" };
  }

  logo: Object = (
    <div className={css.headrow}>
      <img
        className={css.logo}
        src="https://www.indemandradio.com/img/idr-logo-2.png"
        alt="logo"
      />
    </div>
  );

  header: Object = (
    <div className={css.header}>
      <h1>Jammin' In Jamaica!</h1>
      <h3>
        Win a luxury 5 star holiday in beautiful Jamaica - One prize: 7 nights /
        6 days all-inclusive stay for 2 adults at a Sandals Resort + flights
        covered (T&Cs apply)
      </h3>
    </div>
  );

  render(): Object {
    if (this.state.submitPending) {
      return (
        <div>
          {this.logo}
          {this.Loading}
        </div>
      );
    }

    if (this.state.submitStatus > 0 && this.state.submitStatus < 400) {
      return (
        <div>
          {this.logo}
          <div className={css.resultWrapper}>
            <h3>Success!</h3>
            <p>Your entry was submitted successfully.</p>
            <p>Please note - you will *not* receive any confirmation emails</p>
            <p>The winner will be contacted by phone after the closing time.</p>
          </div>
        </div>
      );
    }

    if (this.state.submitStatus >= 400) {
      return (
        <div>
          {this.logo}
          <div className={css.resultWrapper}>
            <h3>Error</h3>
            <p>Sorry, something's gone wrong. Please try again later</p>
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        {this.logo}
        {this.header}
        <div className={css.wrapper}>
          <form onSubmit={(e) => this.handleSubmit(e)}>
            <p className={css.required}>(*) required field</p>
            {/* <input style={{ display: "none" }} value="idr-xmas-2020" name="competition_id" readOnly={true}/> */}
            <fieldset>
              <legend>Your details</legend>
              <Field
                name="name"
                title="Your name"
                // description="Name of the person filling this form in"
                placeholder="your name"
                data={this.state.data}
                onChange={(e) => this.handleChange(e)}
                requiredFields={this.Required}
                errorFields={this.state.errorFields}
                validator={Validator.anytext}
              />

              {/* <Field
                name="dob"
                title="Your Date Of Birth"
                // description="Date of birth of the person filling this form in"
                placeholder="01/02/1990"
                data={this.state.data}
                onChange={(e) => this.handleChange(e)}
                requiredFields={this.Required}
                errorFields={this.state.errorFields}
                validator={Validator.dob}
              /> */}
              {/* 
              <Field
                name="address"
                title="Your address"
                // description="Street address & town of the person filling this form in"
                placeholder="1 My Street, My Town"
                data={this.state.data}
                onChange={(e) => this.handleChange(e)}
                requiredFields={this.Required}
                errorFields={this.state.errorFields}
                validator={Validator.address}
              /> */}

              {/* <Field
                name="postcode"
                title="Your postcode"
                // description="Postcode of the person filling this form in"
                placeholder="postcode"
                data={this.state.data}
                onChange={(e) => this.handleChange(e)}
                requiredFields={this.Required}
                errorFields={this.state.errorFields}
                validator={Validator.postcode}
              /> */}

              <Field
                name="contact_number"
                type="tel"
                title="Your mobile number"
                description="So we can call you back if you win"
                placeholder="07123 456 789"
                data={this.state.data}
                onChange={(e) => this.handleChange(e)}
                requiredFields={this.Required}
                errorFields={this.state.errorFields}
                validator={Validator.uk_phone_number}
              />
              <Field
                name="email"
                type="text"
                title="Your email address"
                description="Required for validating the winners"
                placeholder="name@your-email.com"
                data={this.state.data}
                onChange={(e) => this.handleChange(e)}
                requiredFields={this.Required}
                errorFields={this.state.errorFields}
                validator={Validator.email}
              />

              {/* <Field
                name="gender"
                type="select"
                options={[
                  <option key="none" value="none"></option>,
                  <option key="female" value="female">
                    Female
                  </option>,
                  <option key="male" value="male">
                    Male
                  </option>,
                  <option key="other" value="other">
                    Other
                  </option>,
                ]}
                title="Gender"
                defaultValue="none"
                // description="In case we need to get in touch online"
                //   placeholder="name@your-email.com"
                data={this.state.data}
                onChange={(e) => this.handleChange(e)}
                requiredFields={this.Required}
                errorFields={this.state.errorFields}
                validator={Validator.multi_choice}
              /> */}
              {/* <Field
                name="reason"
                type="textarea"
                title={`Main reason why you'd like to win`}
                description="5000 characters max"
                //   placeholder="person@thevenue.com"
                data={this.state.data}
                onChange={(e) => this.handleChange(e)}
                requiredFields={this.Required}
                errorFields={this.state.errorFields}
                maxLength={5000}
                textAreaRows={10}
                validator={Validator.anytext}
              /> */}
            </fieldset>

            {/* <fieldset>
              <legend>YOUR ANSWER</legend>
              <Field
                name="answer"
                type="text"
                title={`Name the artist!`}
                description="You must name the primary artist of the track for this week"
                //   placeholder="person@thevenue.com"
                data={this.state.data}
                onChange={(e) => this.handleChange(e)}
                requiredFields={this.Required}
                errorFields={this.state.errorFields}
                maxLength={5000}
                textAreaRows={10}
                validator={Validator.anytext}
              />
            </fieldset> */}
            <fieldset>
              <Field
                name="marketing_optin"
                type="select"
                title="Receive marketing from In Demand Radio and Sandals Resorts?"
                description="Subject to In Demand & Sandals Resorts privacy policies. See https://www.sandals.com/privacy/"
                // placeholder="DROPDOWN"
                data={this.state.data}
                onChange={(e) => this.handleSelectChange(e)}
                requiredFields={this.Required}
                errorFields={this.state.errorFields}
                options={[
                  <option key="none" value="none"></option>,
                  <option key="yes" value="yes">
                    Yes
                  </option>,
                  <option key="no" value="no">
                    No
                  </option>,
                ]}
                defaultValue="none"
                validator={Validator.multi_choice}
              />
            </fieldset>
            <section className={css.smallprint}>
              <p>
                The winner will be picked at random from all correct entries.
              </p>
              {/* <p>
                Closing dates for weekly draws: 15:00 on 4th April, 11th April,
                18th April, 24th April
              </p> */}
              <p>
                Full terms and conditions can be found at{" "}
                <a href="https://idrad.io/rules">https://idrad.io/rules</a>
              </p>
              <p>
                <a href="https://indemand.global/data/">
                  Data protection & privacy policy
                </a>
              </p>
            </section>
            {this.SubmitButtons}
          </form>
        </div>
      </React.Fragment>
    );
  }
}
export default Form;
